export const INIT = "originalReport/INIT";
export const SET = "originalReport/SET";
export const SET_ERRORS = "originalReport/SET_ERRORS";

export const initOriginalReport = () => ({
  type: INIT
});
export const setOriginalReport = res => ({
  type: SET,
  res
});
export const setErrors = errors => ({
  type: SET_ERRORS,
  errors
});

const initialState = {
  originalQuestion: [],
  errors: []
};

const originalReport = (state = initialState, action) => {
  switch (action.type) {
    case INIT: {
      return {
        ...initialState
      };
    }
    case SET: {
      return { ...action.res };
    }
    case SET_ERRORS: {
      return { ...state, errors: action.errors };
    }
    default:
      return state;
  }
};

export default originalReport;



// WEBPACK FOOTER //
// ./src/redux/modules/originalReport.js